<script lang="ts">
    import { createEventDispatcher } from "svelte";
    import "./sub/inputStyle.css";

    const dispatch = createEventDispatcher();

    export let name = "";
    export let userSelected = null;
    export let nullAvalible = false;
    export let optionsList = [];
    export let nativeInput = null;
    export let disabled = false;
    export let defaultVal = null;
    let subDefaultVal = NaN;
    // $: subDefaultVal = (defaultVal) ? defaultVal : (userSelected) ? userSelected : NaN;

    $: dispatch("change", {
        value: userSelected,
    });
</script>

<div class="textBlock" class:textBlockNoLabel={!name}>
    {#if name}
        <span class="standartLabel">{name}</span> <!-- to do -->
    {/if}
    <select
        class="inputRectangle"
        {disabled}
        bind:this={nativeInput}
        bind:value={userSelected}
    >
        {#if nullAvalible}
            <option label="»»  Vyber  ««" value={null} />
        {/if}
        <!-- <option label="»»  Vyber  ««" value={null} hidden={!nullAvalible} /> -->
        {#each optionsList as option}
            <option
                label={option.name}
                value={option.value}
                selected={subDefaultVal === option.value}
            />
        {/each}
    </select>
    <div class="underline">
        <div class="underlineColor focusBackgorund" />
    </div>
</div>

<style>
    .textBlock {
        top: auto;
        bottom: 1.2rem;
    }
    .inputRectangle {
        padding: calc(0.6rem - 2px) 0.5rem 0.4rem 0.5rem;
    }
    .textBlockNoLabel {
        bottom: auto;
        top: calc(0.6rem + 1px);
    }
    .standartLabel {
        margin: 0 0 0.7rem 7px;
        top: 1.5em;
        width: fit-content;
        z-index: 10;
    }
    /*  .name {
        margin: 0 0 0.7rem 7px;
        border-radius: 0.5rem;
        padding: 0.1rem 0.2rem;
        background: var(--back);
        font-size: 0.9rem;
        color: var(--back_D2);
        position: relative;
        top: 1.5em;
        width: fit-content;
        z-index: 10;
    }
    select {
        border: none;
        border-top: solid var(--back_D15) 1px;
        border-left: solid var(--back_D15) 1px;
        border-right: solid var(--back_D15) 1px;
        margin: 0;
        background: white;
        border-radius: 0;
        outline: none;
        padding: 0.6em 0.5rem 0.4rem 0.5rem;
        font-size: 1rem;
        color: var(--back_D2);
        width: 100%;
    } */
    option {
        color: black;
        font-size: 1.15rem;
        font-weight: 300;
    }
    option:checked {
        font-weight: 400;
    }
    option:hover {
        background-color: var(--prim_L2);
    }
    .underline {
        width: 100%;
        height: 4px;
        background: var(--back_D18);
        position: relative;
    }
    .underlineColor {
        height: 100%;
        width: 0;
        transition: width cubic-bezier(0.55, 0.09, 0.68, 0.53) 0.5s;
        position: absolute;
    }
    .text:focus-within .focusBackgorund {
        width: 100%;
    }
</style>
